
export function buildCriteriaPageQueryV1(workspaceId: number, evalModelId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.Hierarchies.Queries.CriteriaPageQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': workspaceId,
		'EvalModelId': evalModelId,
	}
}

export function buildLegacyMeasurementsPageQueryV1(workspaceId: number, projectId: number, evalModelId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.Hierarchies.Queries.LegacyMeasurementsPageQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
	}
}

export function buildMeasurementsPageQueryV1(workspaceId: number, projectId: number, evalModelId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.Hierarchies.Queries.MeasurementsPageQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
	}
}




export function buildAttributeLibraryQueryV1(chId: number, wsId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.Hierarchies.Queries.AttributeLibraryQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': wsId,
		'CriteriaHierarchyId': chId
	}
}

export function buildCriteriaLibraryQueryV1(chId: number, wsId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.Hierarchies.Queries.CriteriaLibraryQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': wsId,
		'CriteriaHierarchyId': chId
	}
}


export function buildCriterionQueryV1(wsId: number, projectId: number, chId: number, criterionId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.Hierarchies.Queries.CriterionQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': wsId,
		'ProjectId': projectId,
		'CriteriaHierarchyId': chId,
		'CriterionId': criterionId
	}
}

export function buildCriteriaHierarchyQueryV1(chId: number, wsId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.Hierarchies.Queries.CriteriaHierarchyQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': wsId,
		'CriteriaHierarchyId': chId
	}
}

export function buildSubcriteriaQueryV1(chId: number, parentId: number, wsId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.Hierarchies.Queries.SubcriteriaQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': wsId,
		'CriteriaHierarchyId': chId,
		'ParentId': parentId
	}
}


export function buildCriteriaHierarchyDependenciesQueryV1(workspaceId: number, chId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.Hierarchies.Queries.CriteriaHierarchyDependenciesQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': workspaceId,
		'CriteriaHierarchyId': chId
	}
}

export function buildCriterionDependenciesQueryV1(workspaceId: number, chId: number, criterionId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.Hierarchies.Queries.CriterionDependenciesQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': workspaceId,
		'CriteriaHierarchyId': chId,
		'CriterionId': criterionId
	}
}




